export default {
  computed: {
    donationAppFeeMaximum() {
      // fetch it from the VITE env variable VITE_DONATIONS_APP_FEE_MAXIMUM
      return parseFloat(import.meta.env.VITE_DONATIONS_APP_FEE_MAXIMUM) || 8.99
    },
    donationAppFeePercent() {
      // round at 2 digits
      return Math.round((parseFloat(import.meta.env.VITE_DONATIONS_APP_FEE_PERCENT) / 100) * 100) / 100 || 0.09;
    },
    donationAppFeeMinimum() {
      return parseFloat(import.meta.env.VITE_DONATIONS_APP_FEE_MINIMUM) || 2
    },
  },
  methods: {
    donationAppFeeAmountProposed(donationAmount) {
      const DonationAppFeeAmount = Math.ceil(donationAmount * this.donationAppFeePercent);

      if (DonationAppFeeAmount <this.donationAppFeeMinimum) {
        return this.donationAppFeeMinimum;
      } else if (DonationAppFeeAmount > this.donationAppFeeMaximum) {
        return this.donationAppFeeMaximum;
      }
      return DonationAppFeeAmount
    },
  }
}
